import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false); // Vidljivost glavnog prozora
    const [showTerms, setShowTerms] = useState(false); // Vidljivost Terms prozora

    useEffect(() => {
        // Proveri da li je korisnik već doneo odluku
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            setIsVisible(true); // Prikazujemo prozor ako nije pronađen zapis u localStorage
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted'); // Sačuvaj odluku
        setIsVisible(false); // Sakrij prozor
    };

    const handleDeny = () => {
        localStorage.setItem('cookieConsent', 'denied'); // Sačuvaj odluku
        window.location.href = "https://www.google.com"; // Preusmeri na Google
    };

    const openTerms = () => {
        setShowTerms(true); // Otvori Terms prozor
    };

    const closeTerms = () => {
        setShowTerms(false); // Zatvori Terms prozor
    };

    if (!isVisible) {
        return null; // Ako je korisnik već doneo odluku, ne prikazuj prozor
    }

    return (
        <>
            {/* Glavni popup za kolačiće */}
            {!showTerms && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <h2 style={styles.heading}>Cookie Consent for Tooristico</h2>
                        <div style={{ margin: '20px 0' }}></div>
                        <p style={styles.text}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin luctus, nunc id laoreet ultrices...
                            <br />
                            <button style={styles.linkButton} onClick={openTerms}>
                                Terms of Use
                            </button>
                        </p>
                        <div style={styles.buttons}>
                            <button style={styles.button} onClick={handleAccept}>Accept</button>
                            <button style={styles.button} onClick={handleDeny}>Deny</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Popup za Terms of Use */}
            {showTerms && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <h2 style={styles.heading}>Terms of Use</h2>
                        <div style={{ margin: '20px 0' }}></div>
                        <p style={{ ...styles.text, marginTop: '30px' }}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin luctus, nunc id laoreet ultrices,
                            augue metus aliquet augue, non placerat sapien lorem in purus. Curabitur sodales purus vel
                            blandit vestibulum. Suspendisse vel laoreet metus. Vivamus tincidunt nisl sed mi convallis...

                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin luctus, nunc id laoreet ultrices,
                            augue metus aliquet augue, non placerat sapien lorem in purus. Curabitur sodales purus vel
                            blandit vestibulum. Suspendisse vel laoreet metus. Vivamus tincidunt nisl sed mi convallis...

                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin luctus, nunc id laoreet ultrices,
                            augue metus aliquet augue, non placerat sapien lorem in purus. Curabitur sodales purus vel
                            blandit vestibulum. Suspendisse vel laoreet metus. Vivamus tincidunt nisl sed mi convallis...
                        </p>
                        <div style={styles.buttons}>
                            <button style={styles.button} onClick={handleAccept}>Accept</button>
                            <button style={styles.button} onClick={handleDeny}>Deny</button>
                            <button style={styles.closeButton} onClick={closeTerms}>Back</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modal: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'center',
        width: '90%',
        maxWidth: '600px',
        fontFamily: 'Montserrat, sans-serif',
    },
    heading: {
        fontFamily: 'Montserrat, sans-serif',
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    text: {
        fontFamily: 'Montserrat, sans-serif',
        fontSize: '16px',
        lineHeight: '1.5',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '20px',
    },
    button: {
        padding: '10px 20px',
        borderRadius: '5px',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#007BFF',
        color: '#fff',
        fontSize: '16px',
        fontFamily: 'Montserrat, sans-serif',
    },
    linkButton: {
        background: 'none',
        border: 'none',
        color: '#007BFF',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontSize: '16px',
        marginTop: '10px',
        fontFamily: 'Montserrat, sans-serif',
    },
    closeButton: {
        padding: '10px 20px',
        borderRadius: '5px',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#6c757d',
        color: '#fff',
        fontSize: '16px',
        fontFamily: 'Montserrat, sans-serif',
    },
};

export default CookieConsent;
